import { FileWithPath } from '@mantine/dropzone';

import { Project } from '@/shared/config/projects';
import { axiosInstance } from '@/shared/core';
import { projectAxios } from '@/shared/core/axios';

import {
  CreatePublisherDTO,
  GetPublisherResponseDTO,
  GetPublishersResponseDTO,
  UpdatePublisherDTO,
} from './dto/publishers.dto';
import { uploadKitabaFile } from './upload';

export async function uploadPublisherPreview(
  project: Project,
  file: FileWithPath,
): Promise<string> {
  if (project === 'kitaba') {
    return (await uploadKitabaFile(file, 'publishers', 'image')).path;
  }
  const formData = new FormData();

  formData.append('image', file);
  return (
    await axiosInstance.post<{ imagePath: string }>(
      '/book/uploadImage',
      formData,
    )
  ).data.imagePath;
}

export async function createPublisher(
  project: Project,
  data: CreatePublisherDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.post('/publishers', {
      title: data.title,
      description: data.description || undefined,
      imgUrl: data.imgUrl || undefined,
      url: data.url || undefined,
    });
    return;
  }
  await axiosInstance.post('/publisher/create', {
    title: data.title,
    description: data.description,
    imgUrl: data.imgUrl,
    url: data.url,
  });
}

export async function getPublisher(
  project: Project,
  id: number,
): Promise<GetPublisherResponseDTO> {
  if (project === 'kitaba') {
    const publisher = (await projectAxios.kitaba.get(`/publishers/${id}`)).data;
    return { ...publisher, language: '' };
  }
  return (
    await axiosInstance.get('/publisher/get', {
      params: {
        publisherId: id,
      },
    })
  ).data;
}

export async function getPublishers(
  project: Project,
): Promise<GetPublishersResponseDTO> {
  if (project === 'kitaba') {
    const response = (await projectAxios.kitaba.get('/publishers')).data;
    return {
      publishers: response.publishers.map(
        (publisher: GetPublisherResponseDTO) => ({
          ...publisher,
          language: '',
        }),
      ),
    };
  }
  return (await axiosInstance.get('/publisher/getAll')).data;
}

export async function updatePublisher(
  project: Project,
  data: UpdatePublisherDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.patch(`/publishers/${data.id}`, {
      title: data.title,
      description: data.description,
      url: data.url,
      ...(data.imgUrl && { imgUrl: data.imgUrl }),
    });
    return;
  }
  await axiosInstance.post('/publisher/update', {
    id: data.id,
    title: data.title,
    description: data.description,
    imgUrl: data.imgUrl,
    url: data.url,
  });
}

export async function deletePublisher(
  project: Project,
  id: number,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.delete(`/publishers/${id}`);
    return;
  }
  await axiosInstance.post('/publisher/delete', {
    id,
  });
}
